export const getAuthData = async () => {

    try{
      const info = {
        user: false,
        session: false
      }
      return info
    }catch(e){
      return {
        user: false,
        session: false
      }
    }
  }
